import * as React from "react";
import { SVGProps, memo } from "react";

const SvgWarnOrange = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.478 19.312 12 4.162l8.522 15.15H3.478Zm9.993-16.36c-.646-1.147-2.297-1.147-2.942 0l-8.843 15.72a1.687 1.687 0 0 0 1.471 2.515h17.685c1.291 0 2.104-1.39 1.471-2.515l-8.842-15.72ZM12 8.25c.518 0 .937.42.937.937v4.125a.938.938 0 0 1-1.875 0V9.187c0-.518.42-.937.938-.937Zm1.125 8.437a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z"
      fill="#E98E16"
    />
  </svg>
);

const Memo = memo(SvgWarnOrange);

export default Memo;
